import type { NodeTypes } from "@xyflow/react";
import { RectangleNode } from "./rectangle-node";
import { CircleNode } from "./circle-node";
import { DiamondNode } from "./diamond-node";
import { HexagonNode } from "./hexagon-node";
import { StickyNoteNode } from "./sticky-note-node";
import { TextNode } from "./text-node";
import { OrgChartCardNode } from "./org-chart-card-node";

export const nodeTypes: NodeTypes = {
  rectangle: RectangleNode,
  circle: CircleNode,
  diamond: DiamondNode,
  hexagon: HexagonNode,
  stickyNote: StickyNoteNode,
  text: TextNode,
  orgChartCard: OrgChartCardNode,
};

export {
  RectangleNode,
  CircleNode,
  DiamondNode,
  HexagonNode,
  StickyNoteNode,
  TextNode,
  OrgChartCardNode,
};
